(function(){
  var mq=window.matchMedia('(max-width: 600px)');
  function placeMobileCta(){
    document.querySelectorAll('.pc-hero').forEach(function(hero){
      var grid=hero.querySelector('.pc-hero__grid');
      var copy=hero.querySelector('.pc-hero__copy');
      var visual=hero.querySelector('.pc-hero__visual');
      var actions=hero.querySelector('.pc-hero__actions');
      var proof=hero.querySelector('.pc-hero__microproof');
      if(!grid||!copy||!visual||!actions)return;
      if(mq.matches){
        if(visual.nextElementSibling!==actions){visual.insertAdjacentElement('afterend',actions);}
        actions.classList.add('pc-actions-mobile-position');
      }else{
        actions.classList.remove('pc-actions-mobile-position');
        if(proof){
          if(actions.nextElementSibling!==proof){copy.insertBefore(actions,proof);}
        }else if(actions.parentElement!==copy){copy.appendChild(actions);}
      }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',placeMobileCta);}else{placeMobileCta();}
  window.addEventListener('resize',placeMobileCta,{passive:true});
  document.addEventListener('shopify:section:load',placeMobileCta);
  document.addEventListener('shopify:section:reorder',placeMobileCta);
})();

(function(){
  function ensureStyle(){
    if(document.getElementById('pc-custom-thumb-style'))return;
    var s=document.createElement('style');
    s.id='pc-custom-thumb-style';
    s.textContent='.pc-custom-modal__selected-preview{position:static;width:118px;height:118px;object-fit:cover;border-radius:16px;border:1px solid #eadfea;background:#f7f3f8;box-shadow:0 8px 22px rgba(67,35,76,.16);display:block!important;margin:8px 0 12px auto}.pc-custom-modal__dialog h3,.pc-custom-modal__price{padding-right:0!important}@media(max-width:600px){.pc-custom-modal__selected-preview{width:92px;height:92px;border-radius:12px;margin-top:6px;margin-bottom:10px}}';
    document.head.appendChild(s);
  }
  function hidePreview(modal){
    if(!modal)return;
    var img=modal.querySelector('.pc-custom-modal__selected-preview');
    if(img){img.removeAttribute('src');img.style.display='none';}
  }
  function showPreview(card){
    if(!card)return;
    var root=card.closest('[data-pc-catalog]') || document;
    var modal=root.querySelector('[data-custom-modal]');
    if(!modal)return;
    var dialog=modal.querySelector('.pc-custom-modal__dialog');
    if(!dialog)return;
    ensureStyle();
    var textarea=dialog.querySelector('[data-custom-note]');
    var img=dialog.querySelector('.pc-custom-modal__selected-preview');
    if(!img){
      img=document.createElement('img');
      img.className='pc-custom-modal__selected-preview';
      img.alt='Vista previa del diseño seleccionado';
    }
    if(textarea){dialog.insertBefore(img,textarea);}else{dialog.appendChild(img);}
    var cardImg=card.querySelector('.pc-gallery-card__preview img');
    var src=card.getAttribute('data-design-preview') || (cardImg && (cardImg.currentSrc || cardImg.src)) || '';
    if(src){
      img.src=src;
      img.style.display='block';
      img.hidden=false;
    }else{
      hidePreview(modal);
    }
  }
  document.addEventListener('click',function(e){
    var pencil=e.target.closest && e.target.closest('[data-open-custom]');
    if(pencil){
      var card=pencil.closest('.pc-gallery-card');
      showPreview(card);
      setTimeout(function(){showPreview(card);},30);
      return;
    }
    var closer=e.target.closest && e.target.closest('[data-custom-close]');
    if(closer){hidePreview(closer.closest('[data-custom-modal]'));}
  },true);
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape')document.querySelectorAll('[data-custom-modal]').forEach(hidePreview);
  });
})();
